import { render, staticRenderFns } from "./ServiceTypeEducationalInfoView.vue?vue&type=template&id=f22fa764&scoped=true"
import script from "./ServiceTypeEducationalInfoView.vue?vue&type=script&lang=js"
export * from "./ServiceTypeEducationalInfoView.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeEducationalInfoView.vue?vue&type=style&index=0&id=f22fa764&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22fa764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f22fa764')) {
      api.createRecord('f22fa764', component.options)
    } else {
      api.reload('f22fa764', component.options)
    }
    module.hot.accept("./ServiceTypeEducationalInfoView.vue?vue&type=template&id=f22fa764&scoped=true", function () {
      api.rerender('f22fa764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/ServiceTypeEducationalInfoView.vue"
export default component.exports